var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserInvertcomponent = function SvgUserInvertcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.477 6a3 3 0 1 1-6 0 3 3 0 1 1 6 0Zm-1.5 0c0-.825-.675-1.5-1.5-1.5s-1.5.675-1.5 1.5.675 1.5 1.5 1.5 1.5-.675 1.5-1.5Zm-1.5 3.75c-2.002 0-6 1.005-6 3V15h12v-2.25c0-1.995-3.997-3-6-3Zm-4.5 3.008v.742h9v-.75c-.15-.533-2.475-1.5-4.5-1.5s-4.35.967-4.5 1.508Z",
    fill: "current"
  })));
};
export default SvgUserInvertcomponent;